/**
 * TEMP — on-screen debug log for server responses. Wires the CLEAR / toggle
 * buttons on first call. Delete this file (and its callers) when debugging
 * is complete.
 */

let wired = false;

export function appendDebugLog(label: string, payload: unknown): void {
  if (typeof document === 'undefined') return;
  const body = document.getElementById('debug-panel-body');
  if (!body) return;
  if (!wired) {
    wired = true;
    const clearBtn = document.getElementById('debug-panel-clear');
    const toggleBtn = document.getElementById('debug-panel-toggle');
    const panel = document.getElementById('debug-panel');
    clearBtn?.addEventListener('click', () => { body.textContent = ''; });
    toggleBtn?.addEventListener('click', () => {
      if (!panel) return;
      const collapsed = panel.getAttribute('data-collapsed') === 'true';
      panel.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
    });
  }
  const stamp = new Date().toLocaleTimeString();
  let pretty: string;
  try {
    pretty = JSON.stringify(payload, null, 2);
  } catch {
    pretty = String(payload);
  }
  const entry = document.createElement('div');
  entry.textContent = `[${stamp}] ${label}\n${pretty}\n\n`;
  body.appendChild(entry);
  body.scrollTop = body.scrollHeight;
}
